// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Adz7m","active":"styles_active__Z2zW5","disabled":"styles_disabled__Zeafd"};